const brandId = 1 // mazda
const host = "https://serviceforms.delek-motors.co.il/Home"
import axios from "axios"

export interface DelekResponse<T> {
  error: string | null
  data: T[]
  result: boolean
}

export interface RecallData {
  brandId: number
  chassisNumber: string
  description: string
  id: number
  licenseNumber: string
  numberCol: number
  reportingDate: string
  shortName: string
}

export interface WarrantyBaseData {
  component: string
  extensionDuration: string
  id: number
  phenomenonDesc: string
}

export interface WarrantyData extends WarrantyBaseData {
  brandId: number
  chassisNumber: string
  description: string
  licenseNumber: string
}

export interface ReplacementsData {
  id: number
  brandId: number
  foreignName: string
  isOriginal: string
  isWithQuantity: string
  item: string
  modelDescription: string
  name: string
  priceWithTax: number
  provider: string
  sku: string
  vehicleModel: string
}

export type DelekRecallsResponse = DelekResponse<RecallData>
export const getRecalls = (data: string, selected: string) => {
  const param = selected === "licenseNumber" ? `licenseNumber` : `chassis`
  const uri = `${host}/GetRecalls?brandId=${brandId}&${param}=${data}`
  return axios.get<DelekRecallsResponse>(uri)
}

export const getServiceInstructions = (data: string, selected: string) => {
  const param = selected === "licenseNumber" ? `licenseNumber` : `chassis`
  const uri = `${host}/GetServiceInstructions?brandId=${brandId}&${param}=${data}`
  return axios.get<DelekRecallsResponse>(uri)
}

export const getColorCodes = (data: string, selected: string) => {
  const param = selected === "licenseNumber" ? `licenseNumber` : `chassis`
  const uri = `${host}/GetColorCodes?brandId=${brandId}&${param}=${data}`
  return axios.get<DelekRecallsResponse>(uri)
}

export type DelekWarrantyExtensionsBaseResponse =
  DelekResponse<WarrantyBaseData>
export const getWarrantyExtensionsTopTable = () => {
  const uri = `${host}/GetWarrantyExtensionsTopTable?brandId=${brandId}`
  return axios.get<DelekWarrantyExtensionsBaseResponse>(uri, { timeout: 10000 })
}

export type DelekWarrantyExtensionsResponse = DelekResponse<WarrantyData>
export const getWarrantyExtensions = (data: string, selected: string) => {
  const param = selected === "licenseNumber" ? `licenseNumber` : `chassis`
  const uri = `${host}/GetWarrantyExtensions?brandId=${brandId}&${param}=${data}`
  return axios.get<DelekWarrantyExtensionsResponse>(uri)
}

export type DelekReplacementsResponse = DelekResponse<ReplacementsData>
export const GetPriceListReplacements = (data: string, param: string) => {
  data = data.trim()
  const uri = `${host}/GetPriceListReplacements?brandId=${brandId}&${param}=${data}`
  return axios.get<DelekReplacementsResponse>(uri)
}
